import { api } from './api.js';
import { TAG_LIST_PA_CHATS } from './tags.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const stt = api.injectEndpoints({
    endpoints: (builder) => ({
        speechToText: builder.mutation({
            query: ({ data }) => ({
                url: '/transcribe',
                method: 'POST',
                body: data,
                multipart: true,
                customURL: `${import.meta.env.VITE_WHISPER_ENDPOINT}`
            })
        }),
        getAiResponse: builder.query({
            query: (params) => ({
                url: `/personal-assistant/ai-response?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        streamSpeechify: builder.mutation({
            query: (body) => ({
                url: '/speechify/stream',
                method: 'POST',
                body,
                responseType: 'blob'
            }),
            transformResponse: (blob) => ({
                audioUrl: URL.createObjectURL(blob.response),
                success: true
            })
        }),
        getAiResponseHistory: builder.query({
            query: (sessionId) => ({
                url: `/personal-assistant/ai-response-history/${sessionId}`,
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deletePAChat: builder.mutation({
            query: ({ sessionId }) => ({
                url: `/personal-assistant/chats/${sessionId}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_PA_CHATS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        updatePATitle: builder.mutation({
            query: ({ sessionId, data }) => ({
                url: `/personal-assistant/chats/${sessionId}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_PA_CHATS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getPAChats: builder.query({
            query: ({ page, per_page } = {}) => {
                const queryParams = new URLSearchParams();
                if (page) queryParams.append('page', page);
                if (per_page) queryParams.append('per_page', per_page);

                return {
                    url: `/personal-assistant/chats?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_LIST_PA_CHATS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getVoicesList: builder.query({
            query: (data) => {
                return {
                    url: `/speechify/voices?${convertToUrlSearchParams(data)}`,
                    method: 'GET'
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getUserVoice: builder.query({
            query: () => {
                return {
                    url: `/speechify/user-voice`,
                    method: 'GET'
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        setUserVoice: builder.mutation({
            query: (data) => ({
                url: `/speechify/voice`,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    }),
    overrideExisting: false
});

export const {
    useSpeechToTextMutation,
    useLazyGetAiResponseQuery,
    useStreamSpeechifyMutation,
    useGetAiResponseHistoryQuery,
    useDeletePAChatMutation,
    useUpdatePATitleMutation,
    useGetPAChatsQuery,
    useLazyGetVoicesListQuery,
    useLazyGetUserVoiceQuery,
    useSetUserVoiceMutation
} = stt;
